<template>
  <div class="min-h-screen px-6 py-8 md:px-10">
    <div class="w-full space-y-6">
      <Breadcrumb :links="breadcrumb" />

      <div class="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
        <div>
          <h1 class="mt-2 text-3xl text-gray-900">Auditoria</h1>
          <p class="mt-2 max-w-2xl text-sm text-gray-500">Consulte os registros de auditoria por período e ação.</p>
        </div>
      </div>

      <div class="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
        <div class="p-6">
          <form>
            <div class="grid grid-cols-1 gap-4 md:grid-cols-5">
              <div class="flex flex-col gap-1">
                <label for="de" class="text-sm font-medium text-gray-500">A partir de</label>
                <input
                  v-model="form.de"
                  type="datetime-local"
                  name="de"
                  id="de"
                  class="h-11 rounded-xl border border-gray-200 px-4 shadow-sm outline-none transition-all duration-200 focus:border-blue-100 focus:ring-2 focus:ring-blue-100"
                />
              </div>

              <div class="flex flex-col gap-1">
                <label for="ate" class="text-sm font-medium text-gray-500">Até</label>
                <input
                  v-model="form.ate"
                  type="datetime-local"
                  name="ate"
                  id="ate"
                  class="h-11 rounded-xl border border-gray-200 px-4 shadow-sm outline-none transition-all duration-200 focus:border-blue-100 focus:ring-2 focus:ring-blue-100"
                />
              </div>

              <div class="flex flex-col gap-1">
                <label for="acao-select" class="text-sm font-medium text-gray-500">Ação</label>

                <div class="relative group">
                  <select
                    v-model="form.acao"
                    name="acao"
                    id="acao-select"
                    class="w-full h-11 px-4 pr-10 border border-gray-200 rounded-xl bg-white bg-none text-gray-700 shadow-sm appearance-none transition-all duration-200 focus:border-blue-100 focus:ring-2 focus:ring-blue-100 cursor-pointer"
                  >
                    <option value="">Todos</option>
                    <option value="login">Login</option>
                    <option value="upload">Upload</option>
                    <option value="campanhas">Campanha</option>
                    <option value="chats">Chats</option>
                    <option value="respostas">Respostas</option>
                    <option value="operadores">Operadores</option>
                    <option value="relatório">Relatório</option>
                    <option value="consultaNumero">Consulta Número</option>
                  </select>

                  <svg class="select-icon h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                  </svg>
                </div>
              </div>

              <div class="flex items-end">
                <button @click="list" type="button" class="h-11 w-full rounded-xl bg-blue-500 font-medium text-white transition hover:bg-blue-600">Buscar</button>
              </div>

              <div class="flex items-end">
                <a
                  :href="`${apilz}/v1/campanhasLZV2/auditoria/download?token=${$store.state.token}&de=${form.de}&ate=${form.ate}&acao=${form.acao}`"
                  role="button"
                  target="_blank"
                  class="flex h-11 w-full items-center justify-center gap-2 rounded-xl border border-gray-200 bg-white px-4 font-medium text-gray-700 shadow-sm transition hover:bg-gray-50"
                >
                  <svg class="h-5 w-5 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 3v12m0 0l-3.5-3.5M12 15l3.5-3.5M4 21h16" />
                  </svg>
                  Download
                </a>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="w-full overflow-hidden sm:rounded-lg border border-gray-200 bg-white shadow-sm">
        <div class="overflow-x-auto">
          <table class="w-full min-w-max text-sm">
            <thead class="border-b bg-gray-100 tracking-wider text-gray-600">
              <tr>
                <th class="px-6 py-4 text-left font-medium">Data/Hora</th>
                <th class="px-6 py-4 text-left font-medium">Usuário</th>
                <th class="px-6 py-4 text-left font-medium">Ação</th>
                <th class="px-6 py-4 text-left font-medium">Status</th>
                <th class="px-6 py-4 text-left font-medium">IP</th>
                <th class="px-6 py-4 text-left font-medium">Navegador</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="el in listAuditoria" :key="el._id" class="border-b border-gray-100 transition hover:bg-slate-50">
                <td class="px-6 py-5 font-medium text-gray-700">
                  {{ moment(el.data).format("DD/MM/YYYY HH:mm") }}
                </td>

                <td class="px-6 py-5">
                  <div class="flex items-center gap-4">
                    <div class="flex h-11 w-11 items-center justify-center rounded-2xl bg-blue-50 text-sm font-semibold text-blue-700">
                      {{ ((el.acesso && el.acesso.nome) || "").slice(0, 2).toUpperCase() }}
                    </div>

                    <div class="flex flex-col">
                      <span class="font-medium text-gray-800">
                        {{ el.acesso ? el.acesso.nome : "-" }}
                      </span>
                      <span class="text-xs text-gray-400">
                        {{ el.acesso ? el.acesso.email : "-" }}
                      </span>
                    </div>
                  </div>
                </td>

                <td class="px-6 py-5">
                  <span class="rounded-full bg-blue-100 px-3 py-1 text-xs font-medium text-blue-700">
                    {{ el.modulo || "-" }}
                  </span>
                </td>

                <td class="px-6 py-5">
                  <textarea readonly v-model="el.status" class="min-h-[44px] w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-2 text-sm text-gray-700 shadow-sm outline-none"></textarea>
                </td>

                <td class="px-6 py-5 font-medium text-gray-700">
                  {{ el.ip || "-" }}
                </td>

                <td class="px-6 py-5 text-gray-700">
                  {{ el.browser || "-" }}
                </td>
              </tr>

              <tr v-if="listAuditoria.length === 0">
                <td colspan="6" class="px-6 py-12 text-center text-sm text-gray-400">Nenhum registro de auditoria encontrado com os filtros atuais.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <pagination v-model="page" :per-page="perPage" :records="total" @paginate="setPage" class="pagination" />
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      breadcrumb: [
        {
          url: "/relatorios/auditoria",
          value: "Auditoria"
        }
      ],
      route: "auditoria",
      apilz: window.location.hostname === "uno.trestto.com.br" ? "https://uno.trestto.com.br/api" : process.env.VUE_APP_API,
      moment: moment,
      listAuditoria: [],
      page: 1,
      perPage: 25,
      form: {
        acao: "",
        usuario: "",
        de: moment().startOf("d").format("YYYY-MM-DDTHH:mm"),
        ate: moment().endOf("d").format("YYYY-MM-DDTHH:mm")
      },
      total: 0
    };
  },
  methods: {
    async setPage(page) {
      this.page = page;

      const skip = (page - 1) * this.perPage;
      const limit = this.perPage;

      let url = `/v1/campanhasLZV2/auditoria/${skip}/${limit}`;
      url += `?de=${this.form.de}&ate=${this.form.ate}&acao=${this.form.acao}`;

      const listReq = await this.$http.get(url);

      this.listAuditoria = listReq.data.data || [];
      this.total = listReq.data.total || 0;
    },

    async list() {
      this.setPage(1);
    }
  },
  async beforeMount() {
    this.list();
  }
};
</script>

<style scoped>
.select-icon {
  position: absolute;
  right: 0.75rem;
  top: 50%;
  pointer-events: none;
  color: #9ca3af;
  transform: translateY(-50%);
  transition: transform 0.2s ease, color 0.2s ease;
}

#acao-select::-ms-expand {
  display: none;
}

#acao-select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: none !important;
}

.group:focus-within .select-icon {
  color: #6366f1;
  transform: translateY(-50%) rotate(180deg);
}
</style>
